module.exports = __webpack_public_path__ + "img/logo-etv-large@2x.2d232ff8.png";